import { useNavigate } from "react-router-dom"

export function DashboardSyncBankAccount() {
  const navigate = useNavigate()

  return (
    <div className='lg:w-full w-11/12 flex flex-col gap-4'>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
        <div className='w-full flex flex-col items-center gap-4'>
          <div className='w-full flex flex-col items-center gap-4'>
            <button 
              onClick={() => navigate('/syncNewBankAccount')}
              className='w-full p-4 bg-[#FF8C00] hover:bg-[#E67E00] transition duration-200 rounded-full text-3xl font-bold shadow-md'>
                <div className='flex flex-col items-center gap-2'>
                  <p>Sync New Account</p>
                  <p className='text-lg'>Click Here</p>
                </div>
            </button>
            <p>Click the button above to sync a new bank account.</p>
          </div>
        </div>
      </div>
      <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col items-center bg-white font-mont gap-4'>
        <p className='font-bold text-2xl text-[#646464]'>What Do I Do Next?</p>
        <p className='font-bold text-xl text-[#646464]'>You have requested to sync a new bank account. Click <span onClick={() => navigate('/syncNewBankAccount')} className='text-[#FF8C00] underline cursor-pointer'>HERE</span> to sync a new bank account.</p>
      </div>
    </div>
  )
}